<template>
  <div class="blog-featured-slider swiper-container" ref="swiper">
    <div class="swiper-wrapper">
      <a
        :href="slide.url"
        class="swiper-slide slide"
        v-for="(slide, index) in actualSlides"
        :key="index"
        :style="backgroundStyle(slide)"
      ></a>
    </div>
    <div class="overlay" />
    <div class="content">
      <div class="tag">Featured Story</div>
      <h3>{{ currentSlide.title }}</h3>

      <div class="meta">
        <div class="meter">
          <div class="progress" ref="progress"></div>
        </div>
        <div class="page">
          {{ currentSlideIndex + 1 }}/{{ actualSlides.length }}
        </div>
        <div class="navigation">
          <div class="navigation__button navigation__button--prev">
            <i class="fal fa-chevron-left"></i>
          </div>
          <div class="navigation__button navigation__button--next">
            <i class="fal fa-chevron-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.js";

export default {
  name: "BlogFeaturedSlider",
  selector: "#vue-blog-featured-slider",
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentSlideIndex: 0,
      timestamp: Date.now(),
    };
  },
  methods: {
    backgroundStyle(slide) {
      return {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${
          slide.image
        })`,
      };
    },
  },
  computed: {
    currentSlide() {
      return this.actualSlides[this.currentSlideIndex];
    },
    actualSlides() {
      return this.slides.filter((slide) => slide.title);
    },
  },

  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      effect: "fade",
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
      navigation: {
        prevEl: ".navigation__button--prev",
        nextEl: ".navigation__button--next",
        disabledClass: "navigation__button--disabled",
      },
    });

    this.swiper.on("slideChange", () => {
      this.currentSlideIndex = this.swiper.activeIndex;
      this.timestamp = Date.now();
    });

    const loop = () => {
      const msElapsed = Date.now() - this.timestamp;
      const percentage = msElapsed / 7000;
      this.$refs.progress.style.transform = `scaleX(${percentage})`;
      window.requestAnimationFrame(loop);
    };

    loop();
  },
};
</script>

<style lang="scss" scoped>
.blog-featured-slider {
  color: white;
  height: 100%;
}

.slide {
  background-position: center;
  background-size: cover;
  /* width: 100% !important; */
}

.overlay,
.content {
  pointer-events: none;
}

.content {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  padding: 16%;
}

.meta {
  pointer-events: all;
  margin-top: 48px;
  display: flex;
  align-items: center;
  color: $white;
  font-size: 14px;
  letter-spacing: 0;
}

.meter {
  width: 130px;
  height: 2px;
  background: rgba($white, 0.2);
  overflow: hidden;
}

.progress {
  background: $teal-light;
  height: 2px;
  transform-origin: left;
}

.page {
  margin-left: 16px;
  font-weight: 700;
}

.navigation {
  display: flex;
  margin-left: 48px;
}

.navigation__button {
  cursor: pointer;
  &--next {
    margin-left: 16px;
  }

  &--disabled {
    opacity: 0.2;
  }
}

.tag {
  font-size: 10px;
  padding: 4px 8px;
  text-transform: uppercase;
  font-weight: 700;
  background-color: $white;
  color: $black;
  display: inline-block;
}
</style>
